import { Actor } from "@icp-sdk/core/agent"

// createActor fetches a local network's root key in the background, but a
// query verifies its signature against that key, so one fired straight away
// fails with "Invalid signature". Wait for the key first (a no-op on mainnet,
// which uses the built-in key).
export const queryReady = async (actor, network = process.env.DFX_NETWORK) => {
  if (network !== "ic") await Actor.agentOf(actor).fetchRootKey()
  return actor
}
